module.exports = __webpack_public_path__ + "3931e7b5e9c1ba573c1ed9f9b8ab92da.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/images/ch_grid_3-mobile.png
// module id = 124
// module chunks = 1